import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import ProductItem from './ProductItem'
import Loading from '../../components/Loading'
import { Parser } from 'html-to-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './product.module.css'

export default function ProductPage() {
    const [el,setEl] = useState({})
    const [loading, setLoading] = useState(false)

    const  {selectedLang} = useContext(store)
    let lang = translate[selectedLang]

    const htmlParser = new Parser()

    const {id} = useParams()


  useEffect(() =>{
    (async() => {
        setLoading(true)
        const res = await axiosInstance.get(`/use/product/${id}`)
        if(res.data.status){
          setEl(res.data.data)
        }else{
            setEl({})
        }
        setLoading(false)
    })()
  }, [])
    



return (
    <div className={styles['products-page-main']}>
      {loading ? <Loading width={200}/> : 
        <div className={styles['products-page-info']}>
            <p className={styles['products-category']}>{lang.tr_product}</p>
            <div className={styles['product-item-hoc-div']}>
                <ProductItem el={el} page="true" />
            </div>
            <div className={styles['products-page-created']}>
                <FontAwesomeIcon icon={faCalendarDays} />
                <p>{new Date(el.created_at).toLocaleDateString()}</p>
            </div>
            <div className="material">
              {htmlParser.parse(el[`${selectedLang}information`]?.
                            replaceAll(`iframe width="auto" height="auto"`, `iframe width="${0.6*window.innerWidth}" height="${0.6*window.innerWidth/1.6}" allowfullscreen`).
                            replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${0.6*window.innerWidth}"/>`))}
            </div>
        </div>}
    </div>
  )
}
